
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"24","height":"24"}},[_c('path',{attrs:{"fill":"#D9D9D9","d":"M0 0h24v24H0z"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"d":"M19.3 8.9l3.2 3.2-1.4 1.4-3.2-3.2c-.35.2-.725.367-1.125.5s-.825.2-1.275.2c-1.25 0-2.313-.438-3.188-1.313C11.438 8.813 11 7.75 11 6.5c0-1.25.438-2.313 1.313-3.188C13.187 2.438 14.25 2 15.5 2c1.25 0 2.313.438 3.188 1.313C19.563 4.186 20 5.25 20 6.5c0 .45-.067.875-.2 1.275-.133.4-.3.775-.5 1.125zm-3.8.1c.7 0 1.292-.242 1.775-.725C17.758 7.792 18 7.2 18 6.5s-.242-1.292-.725-1.775C16.792 4.242 16.2 4 15.5 4s-1.292.242-1.775.725C13.242 5.208 13 5.8 13 6.5s.242 1.292.725 1.775C14.208 8.758 14.8 9 15.5 9zm1.95 3.7L20 15.25V20c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0118 22H4c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 012 20V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 014 4h5.5a5.06 5.06 0 00-.375 1.287c-.067.442-.1.88-.1 1.313 0 1.817.642 3.333 1.925 4.55 1.283 1.217 2.808 1.825 4.575 1.825.317 0 .633-.02.95-.063a6.22 6.22 0 00.975-.212z"}})])])
          )
        }
      }
    